import { apiClient } from '@/auth';

export type CurrentUser = {
  id: number;
  email: string;
  first_name?: string;
  last_name?: string;
  flags?: Record<string, unknown>;
  /**
   * Explicit role signal (MNT ticket P0-B). Present once the backend ships it;
   * `null` for a user who is neither a clinician nor a patient. The client must
   * never infer role from token shape — see `useResolvedRole`.
   */
  role?: 'clinician' | 'patient' | null;
  is_clinician?: boolean;
  is_patient?: boolean;
  clinician?: {
    id: number;
    hospital_id?: number;
    hospital_ids?: number[];
    flags?: Record<string, unknown>;
  };
};

export const usersApi = {
  async current() {
    const res = await apiClient.get<CurrentUser>(`/users/current`);
    return res.data;
  },
};
